@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  @include transition;
  display: flex;
  background-color: var(--dark-4);
  align-items: center;
  position: relative;
  width: fit-content;
  overflow: hidden;

  [data-autopilot-system-redesign='on'] & {
    background-color: var(--dark-3);
  }

  &.isFullWidth {
    width: 100%;

    .item {
      flex: 1;
    }
  }

  &.isDisabled {
    cursor: not-allowed;
  }

  &.primary {
    border-radius: 999px;
    padding: 2px;

    &:hover {
      background: var(--dark-10);

      .highlighter {
        background: var(--light-80);
        box-shadow: 0px 2px 5px 0px var(--dark-6), 0.5px 0.5px 0px 0px var(--light-90) inset;

        [data-autopilot-system-redesign='on'] & {
          box-shadow: none;
        }
      }
    }
    &.isDisabled {
      .highlighter {
        background: var(--light-40);
      }

      .item {
        color: var(--dark-60);
      }

      [data-autopilot-system-redesign='on'] & {
        .highlighter {
          background: transparent;
        }

        .item {
          color: var(--dark-60);
        }
      }
    }

    [data-autopilot-system-redesign='on'] & {
      border-radius: 8px;
      gap: 1px;
      padding: 2px 2px 3px 2px;

      &:hover {
        background: var(--dark-4);

        .highlighter {
          box-shadow: none;
        }
      }
    }
  }

  &.secondary {
    &.rounded {
      border-radius: 32px;
    }

    padding: 0;
    &:hover {
      background: var(--dark-10);
    }

    &.isDisabled {
      &:hover {
        background: var(--dark-4);
      }

      .highlighter {
        opacity: 0.5;

        [data-autopilot-system-redesign='on'] & {
          opacity: 0.8;
        }
      }

      .item {
        color: var(--dark-60);

        &.itemActive {
          color: var(--light-100);
        }
      }

      [data-autopilot-system-redesign='on'] & {
        .highlighter {
          background: var(--light-100);
        }

        .item {
          color: var(--dark-60);
        }
      }
    }

    border-radius: 7px;

    [data-autopilot-system-redesign='on'] & {
      border-radius: 8px;
      gap: 1px;
      padding: 2px;

      &:hover {
        background: var(--dark-4);

        .highlighter {
          background: var(--light-100);
          box-shadow: none;
        }
      }
    }
  }
}

.highlighter {
  @include transition;
  position: absolute;
  height: 36px;
  left: 0;

  &.primary {
    top: 2.4px;

    border-radius: 32px;
    background: var(--light-60);
    box-shadow: 0.5px 0.5px 0px 0px rgba(255, 255, 255, 0.9) inset, 0px 2px 5px 0px rgba(0, 0, 0, 0.06);

    [data-autopilot-system-redesign='on'] & {
      box-shadow: none;
      background: var(--light-100);
    }
  }

  &.secondary {
    border-radius: 0;
    background: var(--selected-fill);
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.06);

    [data-autopilot-system-redesign='on'] & {
      box-shadow: none;
    }
  }

  &.lg {
    height: 44px;
  }

  [data-autopilot-system-redesign='on'] & {
    background: var(--light-100);
    border-radius: 6px;
    border: 1px solid var(--dark-8);
    height: 28px;
    box-shadow: none;

    &.lg {
      height: 32px;
    }
  }
}

.item {
  @include md-sohne-medium;
  color: var(--dark-80);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 10px;
  z-index: 1;

  &.sm {
    @include sm-sohne-medium;
    height: 32px;
    padding: 6px 10px;

    [data-autopilot-system-redesign='on'] & {
      @include xs-sohne-medium;
      height: 28px;
      padding: 6px 13px;
    }
  }

  &.lg {
    height: 44px;

    [data-autopilot-system-redesign='on'] & {
      @include sm-sohne;
      height: 32px;
    }
  }

  &.itemDisabled {
    cursor: not-allowed;
  }

  &.primary {
    color: var(--dark-80);
  }

  &.secondary {
    @include sm-sohne-medium;
    &.itemActive {
      color: var(--light-100);
      @include transition;
    }
  }

  .itemText {
    padding-bottom: 1px;
  }

  [data-autopilot-system-redesign='on'] & {
    @include xs-sohne-book;
    transition: none;
    background-color: transparent;
    color: var(--dark-90);
    padding: 6px 14px;
    border: none;
    border-radius: 6px;
    height: 28px;

    &.itemActive {
      @include xs-sohne-medium;
      background-color: transparent;
      color: var(--dark-90);
      padding: 6px 14px;
      border: none;
      border-radius: 6px;
      box-shadow: none;

      &.sm {
        @include xs-sohne-medium;
        height: 28px;
        padding: 6px 13px;
      }

      &.lg {
        @include sm-sohne-medium;
      }
    }
  }

  @include for-medium-phone-only {
    flex: 1;
  }
}
